/* import __COLOCATED_TEMPLATE__ from './sq-switch.hbs'; */
/**
An Atomic Switch

This component is meant to be used without a label. If you need a switch
with a label, see the [sq-option-switch](./sq-option-switch.html) component.

```example
@title Basic Usage
@description

@hbs
<p>Unchecked<p>
{{sq-switch}}

<p>Checked<p>
{{sq-switch checked=true}}

<p>Unchecked Disabled<p>
{{sq-switch disabled=true}}

<p>Checked Disabled<p>
{{sq-switch checked=true disabled=true}}

```
@param {String} name - A name for this field.
@param {Any} value - A value that this switch represents **NOTE:** This param is not to be used to represent the switch's state (e.g. a boolean for checked or unchecked), use the `checked` param instead.
@param {Boolean|String} [checked=false] - true or false
@param {Boolean} [disabled=false] - Disabled the switch
@param {Number} [tabindex=0] - passes through to the input giving it a tabindex for keyboard navigation
@param {Function} action - An action to perform when the value of 'checked' changes. Is passed the new 'checked' value of the switch, and the switch's value
*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'span',
  classNames: ['option-toggle', 'switch'],
  classNameBindings: ['checked:switch--is-on', 'checked:option-toggle--is-selected', 'disabled:option-toggle--is-disabled', 'disabled:switch--is-disabled'],
  attributeBindings: ['data-test-switch', 'data-test-switch-on'],
  'data-test-switch': computed('value', function () {
    return this.get('value') || true;
  }),
  'data-test-switch-on': readOnly('checked'),
  checked: false,
  actions: {
    onChange(event) {
      const checked = event.target.checked;
      if (this.action) {
        this.action(checked, this.get('value'));
      }
      this.set('checked', checked);
    }
  }
});